module.exports = __webpack_public_path__ + "static/img/s96.4fbcf752.png";